import { Directive } from "@angular/core";
import { BaseComponent, UserService } from "@mypxplat/xplat/core";

@Directive()
export abstract class ExchangeHomeBaseComponent extends BaseComponent {
  public text: string = "ExchangeHome";

  constructor(userService: UserService) {
    super(userService);
  }
}
